<template>
  <div>
    <div class="panel">
      <div class="panel-section">
        <popular-apps />
      </div>
      <div class="panel-section">
        <my-content ref="myContent" />
      </div>
      <div class="panel-section">
        <bookmarks />
      </div>
      <div class="panel-section">
        <events />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PopularApps from "./PopularApps";
import Bookmarks from "./Bookmarks";
import Events from "./events/Events";
import MyContent from "./MyContent";
import * as CONSTANTS from "@/store/constants";

export default {
  name: "right-panel",
  components: {
    Bookmarks,
    PopularApps,
    Events,
    MyContent,
  },
  created() {
    this.$hhMixpanel.performanceMarkStart(CONSTANTS.PAGE_LOAD_EVENT_RIGHT_PANEL_SECTION);
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {
    // impersonation
    "user.userName": function () {
      this.$refs.myContent.initializeContent();
    },
  },
};
</script>

<style scoped>
.loading-skeleton {
  min-height: 800px;
}
.panel {
  padding-top: 28px;
  padding-left: 2.2rem;
  padding-right: 2.2rem;
}
.panel-section {
  padding-bottom: 1.2rem;
}

@media (max-width: 992px) {
  .panel {
    padding-left: 2.0rem;
    padding-right: 2.0rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/RightPanel.vue